import SlimSelectController from "../core/slim_select_controller"

export default class extends SlimSelectController {
  static values = {
    kind: String,
  }

  events() {
    return {
      search: (searchValue, currentData) => {
        if (searchValue.length < 3) {
          return Promise.reject("Type at least 3 characters …")
        }

        return fetch(
          "/identifiers?" +
            new URLSearchParams({
              "q[kind_eq]": this.kindValue,
              "q[name_or_human_readable_cont]": searchValue,
              "q[sorts]": "human_readable asc",
            }),
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
          },
        )
          .then((res) => res.json())
          .then((data) =>
            data.map((item) => ({
              value: item.name,
              text: item.human_readable,
            })),
          )
      },
    }
  }
}
